export const updateUser = (user, id) => {
  let token = "Bearer " + localStorage.getItem("jwt")
  return fetch(`/api/v1/users/${id}`, {
    method: 'PUT',
    body: JSON.stringify(user),     
    headers: {'Authorization': token,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
    }
  })
  .then(res => res.json())
}

